<template>
  <div
    class="pointer inline-block"
    :class="{
      'text-left': align === 'left',
      'text-center': align === 'center',
      'text-right': align === 'right'
    }"
  >
    <span>{{ label }}</span>
    <el-tooltip effect="dark" :content="content" placement="top">
      <i class="el-icon-info margin-left-5"></i>
    </el-tooltip>
  </div>
</template>
<script >
const __sfc_main = {};
__sfc_main.props = {
  content: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  align: {
    type: String,
    default: 'left'
  }
};
export default __sfc_main;
</script>
<style scoped lang="scss"></style>
